/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const cloud = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#000"
      d="m12.287 8.341-.743-.103a.75.75 0 0 0 .804.85l-.061-.747Zm-6.958-.254a.75.75 0 0 0 .78-1.28l-.78 1.28Zm-1.183 4.83c-1.283 0-2.396-1.115-2.396-2.584H.25c0 2.214 1.704 4.084 3.896 4.084v-1.5ZM14.25 11c0 1.1-.831 1.917-1.767 1.917v1.5c1.845 0 3.267-1.572 3.267-3.417h-1.5ZM4.146 14.417h8.337v-1.5H4.146v1.5ZM1.75 10.333c0-1.294.872-2.323 1.956-2.54l-.294-1.47C1.582 6.689.25 8.37.25 10.333h1.5ZM4.304 7.14c.23-2.118 2-3.389 3.617-3.389v-1.5c-2.33 0-4.791 1.796-5.108 4.727l1.491.162Zm3.617-3.39c2.373 0 3.929 2.29 3.623 4.488l1.486.207c.4-2.886-1.622-6.195-5.11-6.195v1.5Zm4.427 5.339c.96-.079 1.902.77 1.902 1.911h1.5c0-1.928-1.605-3.563-3.524-3.406l.122 1.495ZM3.706 7.793a2.276 2.276 0 0 1 1.623.294l.78-1.28a3.776 3.776 0 0 0-2.697-.484l.294 1.47Z"
    />
  </svg>
)
export default cloud
